import React from 'react';

import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { actions } from './sagaSlice';

export default connect(null, actions)(props => {

    props.logout();

    return <Redirect to='/login' />;
});
